import React, { useReducer, createContext, useContext } from "react";

const MAX_PAGE_SIZE = 9999;
const INIT_PAGE_SIZE = 25;

const initialState = {
  loading: false,
  recent: 0,
  pending: 0,
  scheduled: 0,
  inProgress: 0,
  waitingOnParts: 0,
};

const ACTIONS = {
  REFRESH: "REFRESH",
  GET_DATA_LOADING: "GET_DATA_LOADING",
  GET_DATA_SUCCESS: "GET_DATA_SUCCESS",
};

const reducer = (state, data) => {
  switch (data.action) {
    case ACTIONS.GET_DATA_LOADING: {
      const { payload } = data;

      return {
        ...state,
        loading: payload,
      };
    }

    case ACTIONS.GET_DATA_SUCCESS: {
      const { payload } = data;
      const { kpis } = payload;

      return {
        ...state,
        loading: false,
        ...kpis,
      };
    }

    case ACTIONS.REFRESH:
      return {
        ...state,
        refresh: !state.refresh,
      };

    default:
      throw new Error();
  }
};

const WorkOrderKPIsContext = createContext(initialState);

const WorkOrderKPIsProvider = ({ children }) => {
  const stateAndDispatch = useReducer(reducer, initialState);
  return (
    <WorkOrderKPIsContext.Provider value={stateAndDispatch}>
      {children}
    </WorkOrderKPIsContext.Provider>
  );
};

export const useWorkOrderKPIs = () => useContext(WorkOrderKPIsContext);

export {
  WorkOrderKPIsContext,
  WorkOrderKPIsProvider,
  ACTIONS,
  MAX_PAGE_SIZE,
  INIT_PAGE_SIZE,
};
